import {APIClient} from "../../api/httpClient";

import * as url from "./endpoints";


const api = new APIClient();

//Roles
export const getRoles = () => api.get(url.roles);
export const createRoles = (roles: any) => api.create(url.roles, roles);
export const updateRoles = (roles: any) =>
    api.put(`${url.roles}/${roles.id}`, roles);
export const deleteRoles = (id: any) => api.delete(`${url.roles}/${id}`);
